import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import 'dayjs/locale/en';
import 'dayjs/locale/es';
// jhipster-needle-i18n-language-dayjs-imports - JHipster will import languages from dayjs here

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(relativeTime);
// utc + timezone enable formatting stored UTC instants in the platform timezone (see date-utils.formatAdminInstant).
dayjs.extend(utc);
dayjs.extend(timezone);
